import $ from 'zepto';
import { disableTabs, enableTabs, debounce } from '../../utils';
import { getHeaderClasses, getLoaderSpinnerClasses } from '../../utils/constants/classes';

const SECONDARYTEXTDELAY = 5000;

export default class LoaderSpinner {
  constructor(prefix) {
    Object.assign(this, { prefix }, getLoaderSpinnerClasses(prefix), getHeaderClasses(prefix));
  }

  /**
   * Initialize all spinner layers
   *
   * @param {(HTMLElement|Zepto)} spinnerContainer
   */
  initLoaderSpinnerLayer(spinnerContainer) {
    const $spinnerContainer = $(spinnerContainer);
    this.accessibleText = $spinnerContainer.find(`.${this.prefix}screen-reader-only`);
    this.spinnerTarget = $spinnerContainer.data('target');
    this.secondaryTextDelayTime = $spinnerContainer.data('secondary-text-delay');
    this.secondaryText = $spinnerContainer.find(this.loaderSpinnerSecondaryTextSelector);
    this.secondaryTextShowTime = SECONDARYTEXTDELAY;
    this.id = $spinnerContainer.attr('id');
    this.isHidden = $spinnerContainer.hasClass(`${this.prefix}hidden`);
    // Get initial layer height
    this.initialHeight = $spinnerContainer.css('min-height').replace('px', '');

    if (this.spinnerTarget) {
      $spinnerContainer.addClass(this.loaderSpinnerJsPartialLayerClass).appendTo(`#${this.spinnerTarget}`);
    } else {
      // If full screen loader spinner move it after header

      $spinnerContainer.addClass(this.loaderSpinnerJsFullLayerClass).insertAfter(this.headerSelector);
      this.loaderSpinnerLayerJSFullScreenSelector = $(this.loaderSpinnerJsFullLayerSelector);
    }

    if (this.secondaryText.length) {
      // Hide secondary text in first from screen reader
      this.secondaryText.css('display', 'none');
    }

    // Override default secondaryTextShowTime if it comes as data attr
    if (this.secondaryTextDelayTime) {
      this.secondaryTextShowTime = this.secondaryTextDelayTime * 1000;
    }

    // Excecute showSecondaryText when there is NO
    // 'xvx-hidden' class in layer
    if (!this.isHidden && this.secondaryText.length) {
      this.showSecondaryText();
    }

    return this;
  }

  /**
   * Show secondary text
   */
  showSecondaryText() {
    // show secondary text with delay
    debounce(() => {
      // Skip screen reader to read content twice
      this.accessibleText.css('display', 'none');

      // Give screen reader a second loader state feedback
      this.secondaryText.css('display', 'block');
    }, this.secondaryTextShowTime)();
  }

  /**
   * Show element based on it's ID
   *
   * @param {(HTMLElement|Zepto)} elementId
   */
  showLoaderSpinner() {
    const $spinner = $(`#${this.id}`);
    const $context = $(document.body);
    if (!this.spinnerTarget) {
      // Disable all keyboard focusable elements
      disableTabs($context);
      const $html = $(document.documentElement);
      // Disable window scroll when activate the
      // full screen loader spinner
      $html.addClass(this.overflowHiddenClass);

      $spinner.addClass(this.loaderSpinnerJsFixedClass);
    }

    if (this.secondaryText.length) {
      this.showSecondaryText();
    }
    $spinner.removeClass(`${this.prefix}hidden`);
    $spinner.show();
  }

  /**
   * Hide element based on it's ID
   *
   * @param {(HTMLElement|Zepto)} elementId
   */
  hideLoaderSpinner() {
    this.accessibleText.css('display', 'auto');
    this.secondaryText.css('display', 'auto');
    const $html = $(document.documentElement);
    const $context = $(document.body);
    $html.removeClass(this.overflowHiddenClass);
    $(`#${this.id}`).hide().removeClass(this.loaderSpinnerJsFixedClass);
    $(`#${this.id}`).addClass(`${this.prefix}hidden`);
    enableTabs($context);
  }
}
